import { ApiRequestStore } from '../../../common/apiRequest.store'

class CreateSceneStore extends ApiRequestStore {}

export const createSceneStore: CreateSceneStore = new CreateSceneStore()
